import AppVersion from "@/enum/AppVersion";
import ShopType from "@/enum/ShopType";

export enum AppSubscriptionOrderStatus {
    CANCELED = "CANCELED",
    PAID = "PAID",
    REFUND = "REFUND",
    UNPAID = "UNPAID",
}

export interface OrderUpgradeRecord {
    orderTradeId: string;

    paymentMerchantOrderId?: string;

    /**
     * 创建时间
     */
    created?: string;
    /**
     * 退款时间
     */
    dateRefunded?: string;
    /**
     * 升级记录ID
     */
    id?: number;
    /**
     * 订购订单ID
     */
    orderId?: number;
    /**
     * 实付金额
     */
    paymentAmounts?: number;
    /**
     * 退款金额
     */
    refundAmount?: number;
    /**
     * 店铺ID
     */
    shopId?: number;
    /**
     * 状态
     */
    status?: AppSubscriptionOrderStatus;
    /**
     * 升级后的版本
     */
    upgradeToVersion?: AppVersion;

    shopType: ShopType;

    sellerUsername: string;

    refundOperator?: string;
}

export interface AppSubscriptionOrder {
    tradeId: string;

    /**
     * 订单创建时间
     */
    dateCreated?: string;
    /**
     * 退款时间
     */
    dateRefunded?: string;
    /**
     * 订单ID
     */
    id?: number;
    /**
     * 实付金额
     */
    payments?: number;
    /**
     * 支付时间
     */
    paymentTime?: string;
    /**
     * 平台类型
     */
    platform?: ShopType;
    /**
     * 退款金额
     */
    refundAmounts?: number;
    /**
     * 店铺账号
     */
    sellerUsername?: string;
    /**
     * 订单状态
     */
    status?: AppSubscriptionOrderStatus;
    /**
     * 订单履约结束时间
     */
    subscriptionEnd?: string;
    /**
     * 订单履约开始时间
     */
    subscriptionStart?: string;
    /**
     * 升级记录列表
     */
    upgradeRecords?: OrderUpgradeRecord[];
    /**
     * 应用版本
     */
    version?: AppVersion;

    refundOperator?: string;
}
